export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M11.25 7.13h1.2c.66 0 .99.8.52 1.28l-3.45 3.44c-.29.3-.76.3-1.05 0L5.02 8.41a.75.75 0 01.54-1.29h1.19V3.38c0-.4.34-.75.75-.75h3c.41 0 .75.34.75.75v3.75zM4.5 15.38a.75.75 0 01-.75-.76c0-.4.34-.74.75-.74h9c.41 0 .75.33.75.74 0 .42-.34.76-.75.76h-9z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "18",
    "height": "18",
    "fill": "#707070",
    "viewBox": "0 0 18 18"
  }
};